import { commonAPI } from '@/services-ts/axios'
import type { IPayloadFile } from '@/types/Request'
import type { IFileStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useFileStore = defineStore('file', {
  state: (): IFileStore => ({
    files: [],
  }),

  actions: {
    async GetFileList() {
      const { status, data } = await commonAPI.FileServices.GetFileList()
      this.files = status ? data : []
    },

    async UploadFile(data: IPayloadFile) {
      const { status } = await commonAPI.FileServices.UploadFile(data)

      if (status) {
        void Alert({ message: Format('admin_global_uploaded'), type: 'success' })
        await this.GetFileList()
      }
      return status
    },

    async DeleteFile(Id: string) {
      const { status } = await commonAPI.FileServices.DeleteFile(Id)
      if (status) {
        this.files = this.files.filter(file => file.id !== Id)
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
    },

    async UpdateFile(data: IPayloadFile) {
      const { status } = await commonAPI.FileServices.UpdateFile(data)
      if (status) {
        void Alert({ message: Format('admin_global_updated'), type: 'success' })
        await this.GetFileList()
      }
      return status
    },
  },
})
